// import { Product } from './product';
import { ProductOption } from './productOption';

export class Cart {
    [key: string]: CartItem;
}

export class CartItem {
    product: ProductOption;
    productTags: string[];
    name: string;
    quantity: number;
    discount: number;

    overMaxQty: boolean;
    underMinQty: boolean;
    isBackordering: boolean;

    constructor(product: ProductOption, productTags: string[], name: string, quantity: number, discount: number) {
        this.productTags = productTags;
        this.product = product;
        this.name = name;
        this.quantity = +quantity;
        this.discount = discount;
    }

    get cost(): number {
        if (this.product !== undefined){
            if (this.product.price !== undefined) {
                return (this.product.price) * this.quantity;
            }
        }
    }

    deserialize(input: any) {
        this.productTags = input.productTags;
        this.product = input.product;
        this.name = input.name;
        this.quantity = +input.quantity;
        this.discount = input.discount;
        return this;
    }
}

export interface CartFormItem {
    productCode: string, 
    quantity: number
}


export interface Order {

    items: CartItem[],
    shippingAddress: any,
    billingAddress: any,
    creditCard: any
    shippingMethod: string,
    shippingTotal: number,
    donationTotal: number,
    discountTotal: number
}

export interface OrderResponse {
    slug: string,
    subTotal: number,
    shippingTotal: number,
    totalWithShipping: number,
    shippingAddress: any,
    billingAddress: any,
    creditCard: any,
    items: CartItem[]
}



// WEBPACK FOOTER //
// ./src/app/core/models/cart.ts